import React, { useState } from "react";
import { useTranslation } from "../../localization/useTranslation";
import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import AddLegalEntityDialog from "../addLegalEntityDialog/AddLegalEntityDialog";
import { Box } from "@mui/material";
import { useDotLegalQueryClient } from "@common/hooks/dotLegalReactQuery";
import { useCreateAndNavigate } from "../useCreateAndNavigate";
import { CreateLegalEntityReturnType } from "../legalEntities/LegalEntities.types";

export interface ILegalEntityAddButtonProps {
    onLegalEntityCreated: (id: string) => void;
    createAndNavigateName?: string;
    createAndNavigateReturnType?: CreateLegalEntityReturnType;
}

export default function LegalEntityAddButton(props: ILegalEntityAddButtonProps) {
    const [showDialog, setShowDialog] = useState(false);
    const queryClient = useDotLegalQueryClient();
    const { translateString } = useTranslation();
    const createAndNavigate = useCreateAndNavigate(props.createAndNavigateName, props.createAndNavigateReturnType);

    function OnEntityCreated(id: string) {
        props.onLegalEntityCreated(id);

        queryClient.refetchQueries("senderstrue");
        queryClient.refetchQueries("legalEntities");

        setShowDialog(false);
    }

    return (
        <React.Fragment>
            <Box
                sx={(theme) => ({
                    "& .MuiButton-root": {
                        fontWeight: theme.typography.fontWeightBold,
                    },
                })}
            >
                <DotLegalButton btnLength={190} buttonType="secondary" onClick={() => setShowDialog(true)}>
                    {translateString("createCompany")}
                </DotLegalButton>
            </Box>

            {showDialog && (
                <AddLegalEntityDialog
                    onDialogClose={() => setShowDialog(false)}
                    onEntityCreated={(id) => OnEntityCreated(id)}
                    onCreatedAndRedirect={createAndNavigate}
                />
            )}
        </React.Fragment>
    );
}
